import {useEnvironment} from '@wix/yoshi-flow-editor'
import React, {useEffect} from 'react'
import {TPAComponentsProvider} from 'wix-ui-tpa/cssVars'
import {ErrorPage} from '../../../../../commons/components/error-page'
import {DatesProvider} from '../../../../../commons/hooks/dates'
import {StylesForAllBreakpointsProvider} from '../../../../../commons/hooks/styles-for-all-breakpoints'
import {usePrevious} from '../../../../../commons/hooks/use-previous'
import {MembersViewState} from '../../../constants'
import {MembersPageAppProps} from '../../../interface'
import {AppContainer} from '../app-container'
import {MembersPageRuntimeContext} from '../runtime-context/context'

export const App = (props: MembersPageAppProps) => {
  const {state, isRTL, host, actions, isRendered, viewState} = props
  const {isMobile, isPreview} = useEnvironment()
  const prevFormFactor = usePrevious(host.formFactor)

  useEffect(() => {
    actions.handleViewState(!viewState ? MembersViewState.DEFAULT : viewState)
  }, [viewState])

  useEffect(() => {
    if (actions && host && state) {
      if (isPreview && host.formFactor !== prevFormFactor) {
        actions.setFormFactor(host.formFactor)
      }
    }
  }, [host.formFactor])

  if (!state) {
    if (!isRendered) {
      return null
    }
    return <ErrorPage viewMode={host.viewMode} />
  }

  return (
    <MembersPageRuntimeContext.Provider value={props}>
      <TPAComponentsProvider value={{mobile: isMobile}}>
        <DatesProvider dates={state.dates}>
          <StylesForAllBreakpointsProvider>
            <AppContainer isRTL={isRTL} />
          </StylesForAllBreakpointsProvider>
        </DatesProvider>
      </TPAComponentsProvider>
    </MembersPageRuntimeContext.Provider>
  )
}
